import { useState, useCallback } from "react";
import Container from "../../../common/Container";
import LoadingDisplay from "../../../common/LoadingDisplay/LoadingDisplay";
import SelectManager from "./SelectManager";
import memeService from "../../../../services/MemeService";
import "./Selected.css";
import BlueProgressBar from "../../../common/BlueProgressBar";
import BlueScrollBackToTopButton from "../../../common/BlueScrollBackToTopButton";
import PreloadTemplateService from "../../../../services/PreloadService/PreloadTemplateService";
import notificationService from "../../../../services/NotificationService";
import { useTranslation } from "react-i18next";
import useAsync from "../../../../services/useAsync";

const Selected = () => {
    const { t } = useTranslation("templatesPage");

    const {
        selectedTemplates,
        replaceSelectedTemplate,
        deleteSelectedTemplate,
        loadSelectedTemplates,
        updateSelectedTemplate,
    } = PreloadTemplateService();

    const [isLoading, setIsLoading] = useState(true);
    const [userSettings, setUserSettings] = useState(null);
    const [priceOptions, setPriceOptions] = useState(null);

    const loadUserSettings = async () => {
        let settings = await memeService.getBroadcasterSettings();
        setUserSettings(settings);
        return;
    };

    const getPriceList = async () => {
        try {
            const priceOptionsResponse = await memeService.getPriceOptions();
            setPriceOptions(priceOptionsResponse.priceOptions);
        } catch (error) {
            notificationService.setMessage(t("cannotGetPriceMessage"));
        }
    };

    const loadPage = useCallback(async () => {
        setIsLoading(true);

        await Promise.all([
            loadSelectedTemplates(),
            loadUserSettings(),
            getPriceList(),
        ]);

        setIsLoading(false);
    }, [loadSelectedTemplates]);

    useAsync(loadPage);

    //display either loading or selected templates
    const displaySelection = () => {
        if (isLoading) return <LoadingDisplay />;

        if (!isLoading) {
            return (
                <div className="scrollableContainer">
                    <BlueScrollBackToTopButton
                        buttonShowThreshold={1000}
                        left={true}
                    />
                    <Container
                        isNoBackground={true}
                        content={
                            <BlueProgressBar
                                title={t("selectPageTitleProgressBar")}
                                max={userSettings.storageLimit}
                                selected={selectedTemplates.length}
                            />
                        }
                    />
                    <br />
                    <br />
                    {
                        <SelectManager
                            selectedTemplates={selectedTemplates}
                            replaceSelectedTemplate={replaceSelectedTemplate}
                            deleteSelectedTemplate={deleteSelectedTemplate}
                            updateSelectedTemplate={updateSelectedTemplate}
                            priceOptions={priceOptions}
                        />
                    }
                </div>
            );
        }
    };

    return displaySelection();
};

export default Selected;
